import { render } from "./itinerario.vue?vue&type=template&id=086d12ac&scoped=true"
import script from "./itinerario.vue?vue&type=script&lang=js"
export * from "./itinerario.vue?vue&type=script&lang=js"

import "./itinerario.vue?vue&type=style&index=0&id=086d12ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086d12ac"]])

export default __exports__